var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep3Vendor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2054 2052",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2053.1,632.285L1669.77,632.285C1669.77,632.285 1619.37,560.656 1501.88,470.063C1374.85,372.103 1134.19,378.462 1026.55,471.492C884.839,593.967 746.314,720.175 660.288,823.571C553.972,951.354 765.735,1199.11 912.811,1086.21C957.301,1052.05 1216.15,814.473 1216.15,814.473",
    style: {
      fill: "none",
      stroke: "rgb(44,84,106)",
      strokeWidth: 100
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2053.1,1327.37L1580.47,1326.18",
    style: {
      fill: "none",
      stroke: "rgb(44,84,106)",
      strokeWidth: 100
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,120.613,-9.51579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-156.601,625.924L252.251,636.578C252.251,636.578 432.871,403.813 582.431,408.642C785.122,415.186 832.223,517.215 832.223,517.215",
    style: {
      fill: "none",
      stroke: "rgb(44,84,106)",
      strokeWidth: 100
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-120.613,1338.67L218.553,1336.88C218.553,1336.88 508.236,1622.69 580.35,1666.53C614.887,1687.53 685.145,1705.8 726.783,1686.06C765.913,1667.51 836.839,1597.49 836.839,1597.49C836.839,1597.49 957.314,1707.4 1056.73,1657.09C1161.89,1603.89 1159,1505.95 1159,1505.95C1159,1505.95 1278.97,1559.05 1358.94,1477.62C1456.82,1377.95 1403.65,1270.86 1366.27,1234.15C1296.1,1165.24 1037.09,910.873 1037.09,910.873",
    style: {
      fill: "none",
      stroke: "rgb(44,84,106)",
      strokeWidth: 100
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3Vendor);
export default __webpack_public_path__ + "static/media/step3Vendor.f2995c82bf0585c11c2e7594d57513b5.svg";
export { ForwardRef as ReactComponent };